import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap'
import axios from "axios";
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import { useParams } from 'react-router-dom';
import MultiCarouselPage from '../../components/MultiCarouselPage';
import $ from 'jquery'


const ReportFriendshipTarget = props => {
    const { target, sId, roomId } = useParams();
    const [imageAnswer, setImageAnswer] = useState([]);
    const [textAnswer, setTextAnswer] = useState('');
    const [testSelf, setTextSelf] = useState([]);
    const [text1, setText1] = useState([]);
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [renderTarget, setRenderTarget] = useState('me');
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const [accessDenied, setAccessDenied] = useState(false);
    const [userId, setUserId] = useState('');

    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            // partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }
    const responsive2 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }

    const headers = {
        me: 'ผลประเมินจากมุมมองตัวเอง',
        teacher: 'ผลประเมินจากมุมมองของคุณครู',
        friends: 'ผลประเมินจากมุมมองของเพื่อนๆ'
    }
    const subHeaders = {
        me: 'ในช่วงที่ผ่านมา มีเหตุการณ์มากมายที่เกิดขึ้นกับตัวเรา แล้วจากเหตุการณ์ที่ผ่านมาทั้งหมดนั้นทำให้เรามองเห็นอุปนิสัยเชิงบวกอะไรเกิดขึ้นในตัวเองบ้าง? ลองเล่าให้ฟังหน่อยนะคะ',
        teacher: 'หลายเรื่องราวที่ผ่านเข้ามาในชีวิตของเรามันทำให้คุณครูมองเห็นอุปนิสัยเชิงบวกข้อไหนของเราบ้าง?',
        friends: 'หลายเรื่องราวที่ผ่านเข้ามาในชีวิตของเรามันทำให้เพื่อนๆ มองเห็นอุปนิสัยเชิงบวกข้อไหนของเราบ้าง?'
    }

    const commentHeaders = {
        me: 'เหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของตัวเอง',
        teacher: 'เหตุการณ์ที่ทำให้คุณครูมองเห็นอุปนิสัยเชิงบวกของเรา'
    }

    useEffect(() => {
        let userId = null
        let renderTarget
        if (sId) {
            userId = sId
            renderTarget = 'friends'
            setRenderTarget('friends')
        } else {
            userId = AuthService.getCurrentUser().id
            renderTarget = target
            setRenderTarget(target)
        }
        setUserId(userId)
        let newStrengths = []
        var calIndex = 0;
        if (userId) {
            try {
                UserService.getUserById(userId).then((response) => {
                    if (response.data && response.data.data && (response.data.data.id === userId)) {
                        setAccessDenied(true)
                        UserService.getStrengths().then((response) => {
                            for (const [index, str] of response.data.data.entries()) {
                                newStrengths[str.id] = {
                                    image: str.imageUrl,
                                    name: str.name,
                                    description: str.description
                                }
                            }
                            return response.data.data
                        }).then((apiStrengths) => {
                            UserService.getFriendShipList(userId, { roomId }).then((response) => {
                                if (response.data.status.code === 'SUCCESS' && response.data.data && response.data && response.data.data[0] && response.data.data[0].others) {
                                    const data = response.data.data[0].others
                                    let evaluate = null
                                    var images0 = [];
                                    if (renderTarget === "me" || renderTarget === "teacher") {
                                        if (renderTarget === "me") {
                                            evaluate = data.filter(function (d) { return d.user.id === userId })[0];
                                        } else if (renderTarget === "teacher") {
                                            evaluate = data.filter(function (d) { return d.user.roles.includes("TEACHER") && d.answerAt !== null });

                                            if (evaluate[0]) {
                                                evaluate = evaluate[0];
                                            } else {
                                                evaluate = data.filter(function (d) { return d.user.roles.includes("TEACHER") })[0];
                                            }
                                        }

                                        const str0 = apiStrengths.filter(function (strength) { return strength.id === evaluate.answers[0].values[0] })[0];
                                        const str1 = apiStrengths.filter(function (strength) { return strength.id === evaluate.answers[1].values[0] })[0];
                                        const str2 = apiStrengths.filter(function (strength) { return strength.id === evaluate.answers[2].values[0] })[0];

                                        const imgPath = [
                                            str0.imageUrl.replace(/^.*[\\\/]/, ''),
                                            str1.imageUrl.replace(/^.*[\\\/]/, ''),
                                            str2.imageUrl.replace(/^.*[\\\/]/, '')
                                        ]

                                        const StrID = [
                                            str0,
                                            str1,
                                            str2
                                        ]

                                        if (evaluate) {
                                            Object.keys([1, 2, 3]).map((aArray, i) => {
                                                stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${imgPath[i]}' class="d-inline w-100  cardimage i0${i}" />`;
                                                let headline = ['อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                                                    'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                                                    'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา'
                                                ]
                                                var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i0-${i}" onClick={() => { cardClick(aArray, '.tab0', StrID[i], '.i0' + StrID[i].id, headline[i]) }} />
                                                images0.push(temp);
                                            })

                                            setData1(images0);
                                            setTextAnswer(evaluate.answers && evaluate.answers[3] && evaluate.answers[3].values && evaluate.answers[3].values[0] ? evaluate.answers[3].values[0] : '')
                                        }
                                    } else if (renderTarget === "friends") {
                                        var allAnswer0 = [];
                                        var allAnswer1 = [];
                                        var allAnswer2 = [];
                                        var allAnswer3 = [];
                                        var selfText = '';
                                        var images1 = [];
                                        var images2 = [];
                                        var stringHtml;
                                        console.log("response.data.data[0].others.entries()");
                                        console.log(response.data.data[0].others);
                                        for (const [index, aAnswer] of response.data.data[0].others.entries()) {
                                            if (aAnswer.user.roles[0].toLowerCase() !== 'teacher' && aAnswer.answerAt !== null && aAnswer.user.id !== userId) {
                                                if (allAnswer0[aAnswer.answers[0].values[0]] === undefined) {
                                                    allAnswer0[aAnswer.answers[0].values[0]] = 1;
                                                } else {
                                                    allAnswer0[aAnswer.answers[0].values[0]]++
                                                }

                                                if (allAnswer0[aAnswer.answers[1].values[0]] === undefined) {
                                                    allAnswer0[aAnswer.answers[1].values[0]] = 1;
                                                } else {
                                                    allAnswer0[aAnswer.answers[1].values[0]]++
                                                }

                                                if (allAnswer0[aAnswer.answers[2].values[0]] === undefined) {
                                                    allAnswer0[aAnswer.answers[2].values[0]] = 1;
                                                } else {
                                                    allAnswer0[aAnswer.answers[2].values[0]]++
                                                }

                                                // if (allAnswer1[aAnswer.answers[1].values[0]] === undefined) {
                                                //     allAnswer1[aAnswer.answers[1].values[0]] = 1;
                                                // } else {
                                                //     allAnswer1[aAnswer.answers[1].values[0]]++
                                                // }


                                                // if (allAnswer2[aAnswer.answers[2].values[0]] === undefined) {
                                                //     allAnswer2[aAnswer.answers[2].values[0]] = 1;
                                                // } else {
                                                //     allAnswer2[aAnswer.answers[2].values[0]]++
                                                // }


                                                if (props.studentId === aAnswer.user.id) {
                                                    selfText = aAnswer.answers[3].values[0];
                                                    setTextSelf(selfText);
                                                } else {
                                                    allAnswer3[calIndex] = {
                                                        'code': calIndex,
                                                        'text': aAnswer.answers[3].values[0]
                                                    }
                                                    calIndex++;
                                                }
                                            }

                                        }
                                        var myArr0 = Object.fromEntries(
                                            Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                                        );
                                        console.log(myArr0)

                                        Object.keys(myArr0).map((aArray, i) => {
                                            console.log(aArray)
                                            stringHtml = `<div class="primary-text percent-font" data-value="1">${allAnswer0[aArray] > 1 ? `<button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button>` : ''}<img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                                            var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i0-${i}" onClick={() => { cardClick(aArray, '.tab0', newStrengths[aArray], '.i0' + aArray) }} />
                                            images0.push(temp);
                                        })

                                        var myArr1 = Object.fromEntries(
                                            Object.entries(allAnswer1).sort(([, a], [, b]) => b - a)
                                        );

                                        Object.keys(myArr1).map((aArray, i) => {
                                            stringHtml = `<div class="primary-text percent-font" data-value="1">${allAnswer1[aArray] > 1 ? `<button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer1[aArray]}</button>` : ''}<img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i1${aArray}" />`;
                                            var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i1-${i}" onClick={() => { cardClick(aArray, '.tab1', newStrengths[aArray], '.i1' + aArray) }} />
                                            images1.push(temp);
                                        })

                                        var myArr2 = Object.fromEntries(
                                            Object.entries(allAnswer2).sort(([, a], [, b]) => b - a)
                                        );

                                        Object.keys(myArr2).map((aArray, i) => {
                                            stringHtml = `<div class="primary-text percent-font" data-value="1">${allAnswer2[aArray] > 1 ? `<button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer2[aArray]}</button>` : ''}<img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i2${aArray}" />`;
                                            var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i2-${i}" onClick={() => { cardClick(aArray, '.tab2', newStrengths[aArray], '.i2' + aArray) }} />
                                            images2.push(temp);
                                        })
                                        const items = []

                                        for (const [index, value] of allAnswer3.entries()) {
                                            var temp = `<div class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left font-sarabun">${value.text}</div></div>`;
                                            temp = <div dangerouslySetInnerHTML={{ __html: temp }} class="anywhere-wrap" key="t-${index}" />
                                            items.push(temp);
                                        }
                                        setText1(items);
                                        setData1(images0);
                                        setData2(images1);
                                        setData3(images2);
                                    }
                                }
                            });
                        });
                    }
                }).catch(error => {
                    $(".no-access-text").removeClass("d-none");
                });
            } catch (error) {
            }
        }

    }, []);


    const goto = (target, newTab = false) => {
        if (target && newTab) {
            window.open(target, '_blank').focus();
        } else if (target) {
            window.location.href = `/report/friendship/${target}/${roomId}`
        }
    }

    return (
        <div>

            {(accessDenied) ? (
                <div className="report-friendship pb-5">
                    <Row className="bg-light-blue py-5">
                        <Col className="main-evaluate-overview pb-3">
                            <Row>
                                <Col xs={12} className="w-100 text-center">
                                    <h2 className="primary-text font-sarabun-bold">{headers[renderTarget]}</h2>
                                    <h4 className="mx-2 font-sarabun-bold text-left">{subHeaders[renderTarget]}</h4>
                                    <div>
                                        <Button className="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold" onClick={() => goto(`/report/friendship/export/${target}/${roomId}/${userId}`, true)}>Export</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {(renderTarget === 'me' || renderTarget === 'teacher') ? (
                        <Row >
                            <Col className="main-evaluate-overview">
                                <Row className="mx-3">
                                    <Col xs={12} className="px-3 pt-4 pb-2 d-inline w-100 text-center">
                                        <h4 className="font-sarabun-bold">
                                            <img src='/images/evaluate/search.png' class="evaluate-search" /> อุปนิสัยเชิงบวกในตัวของคุณ
                                        </h4>

                                    </Col>
                                </Row>
                                <Row className="bg-white mx-0">
                                    <Col className="px-0">
                                        <MultiCarouselPage data={data1} responsive={responsive3} />
                                    </Col>
                                </Row>
                                <Row className="py-3 bg-white mx-0 tab0 tab">
                                </Row>
                                <Row>
                                    <Col className="w-100 pt-0 text-center">
                                        <h4 class="mx-2 font-sarabun-bold">{commentHeaders[renderTarget]}</h4>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="w-100 px-4">
                                        <div className={`border-radius-12 border-blue p-3 text-left overflow-7 div-ans auto-height`}>
                                            <div className="font-sarabun">{textAnswer}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    ) : (

                        <Row className="pt-3 pb-5 report-tab">
                            <Col className="main-evaluate-overview">
                                <Row className="mx-3">
                                    <Col className="w-100 text-center pt-3">
                                        <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />  อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา</h4>
                                    </Col>
                                </Row>
                                <Row className="py-1 bg-white mx-0">
                                    <Col className="px-0">
                                        <MultiCarouselPage data={data1} responsive={data1.length > 3 ? responsive2 : responsive3} />
                                    </Col>
                                </Row>
                                <Row className="py-1 bg-white mx-0 tab0 tab">
                                </Row>
                                {/* <Row className="mx-3">
                                    <Col className="w-100 text-center pt-3">
                                        <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />  อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา</h4>
                                    </Col>
                                </Row>
                                <Row className="py-1 bg-white mx-0">
                                    <Col className="px-0">
                                        <MultiCarouselPage data={data2} responsive={data2.length > 3 ? responsive2 : responsive3} />
                                    </Col>
                                </Row>
                                <Row className="py-1 bg-white mx-0 tab1 tab">
                                </Row>
                                <Row className="mx-3">
                                    <Col className="w-100 text-center pt-3">
                                        <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />  อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา</h4>
                                    </Col>
                                </Row>
                                <Row className="py-1 bg-white mx-0">
                                    <Col className="px-0">
                                        <MultiCarouselPage data={data3} responsive={data3.length > 3 ? responsive2 : responsive3} />
                                    </Col>
                                </Row> */}
                                <Row className="py-1 bg-white mx-0 tab2 tab">
                                </Row>
                                <Row>
                                    <Col className="w-100 text-center mt-3 my-2">
                                        <h4 class="font-sarabun-bold">เหตุการณ์ที่ทำให้เพื่อนๆ มองเห็นอุปนิสัยเชิงบวกของเรา</h4>
                                    </Col>
                                </Row>
                                <Row className="pb-3 bg-white mx-0 mb-5">
                                    <Col className="px-0">
                                        <MultiCarouselPage data={text1} responsive={text1.length > 3 ? responsive2 : responsive3} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )}

                </div>
            ) : (
                <div align="center">
                    <h1 className="red-text mt-5 no-access-text d-none">Access Denied</h1>
                </div>
            )}
        </div>

    )

    function cardClick(key, tab, str, ele, headline = '') {
        console.log(tab, str, ele)
        $('.tab').html('');
        $('body').find('.cardimage').removeClass("border-card");
        $('body').find(ele).addClass("border-card");
        console.log(headline)
        if (headline) {
            headline = `<h5 class="font-sarabun-bold font-default">${headline}</h5>`
        }
        $(tab).html('<div class="str-div">' + headline + '<h5 class="font-sarabun-bold">' + str.name + '</h5><h6 class="font-sarabun">' + str.description + '</h6></div>');

    }

}

export default ReportFriendshipTarget